import React from 'react';
import { Icon } from 'library';

import './IconList.scss';

const IconList = ({ items = [], iconSize = '2x' }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <ul className="IconList">
      {items.map((item) => {
        return (
          <li key={item.title}>
            <Icon name={item.icon} size={iconSize} />
            {item.title && <h4>{item.title}</h4>}
            <div>{item.text}</div>
          </li>
        );
      })}
    </ul>
  );
};

export default IconList;
